import { render, staticRenderFns } from "./TaskAddInChat.vue?vue&type=template&id=69a6a2aa&scoped=true&"
import script from "./TaskAddInChat.vue?vue&type=script&lang=js&"
export * from "./TaskAddInChat.vue?vue&type=script&lang=js&"
import style0 from "./TaskAddInChat.vue?vue&type=style&index=0&id=69a6a2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a6a2aa",
  null
  
)

export default component.exports